/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import Grid from '@mui/material/Grid'

import MDBox from 'components/MDBox'
import DashboardLayout from 'modules/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'modules/Navbars/DashboardNavbar'

import BusinessAccountBulkImport from './components/BusinessAccountBulkImport'
import OrganisationMemberBulkImport from './components/OrganisationMemberBulkImport'

function Import(): JSX.Element {
	// TODO: Allow user to download example format or do info card.
	return (
		<DashboardLayout>
			<DashboardNavbar isMini />
			<MDBox mt={4}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<MDBox mb={3}>
							<OrganisationMemberBulkImport />
						</MDBox>
					</Grid>
					<Grid item xs={12}>
						<MDBox mb={3}>
							<BusinessAccountBulkImport />
						</MDBox>
					</Grid>
				</Grid>
			</MDBox>
		</DashboardLayout>
	)
}

export default Import
